<div class="modal-header">
  <span *ngIf="title" class="modal-title">{{ title | translate }} </span>
  <span *ngIf="!title" class="modal-title">{{ (isEdit ? 'UPDATE' : '') | translate }} {{ meta?.caption}} </span>
</div>

<div class="modal-body bg-white">
  <ngb-alert *ngIf="info" type="info" [dismissible]="false">
    <i class="fa fa-lg fa-lightbulb-o"></i>
    {{info}}
  </ngb-alert>

  <form>
    <ng-template [ngTemplateOutlet]="form"></ng-template>
  </form>
</div>

<div class="modal-footer bg-white">
  <dx-button *ngIf="!readonly" id="check" type="success" icon="check" useSubmitBehavior="true" validationGroup="main"
    [disabled]="loading || invalid" (onClick)="submit($event)">
  </dx-button>

  <dx-button *ngIf="!readonly && !hiddenApply" id="save" icon="save" type="default" validationGroup="main"
    [disabled]="loading || invalid" (onClick)="submit($event)">
  </dx-button>

  <dx-button *ngIf="!hiddenCancel" id="close" icon="close" type="normal" (onClick)="cancel($event);"
    [disabled]="loading">
  </dx-button>

  <dx-button *ngIf="!readonly && !hiddenReset" id="clear" icon="clearformat" type="danger" stylingMode="outlined"
    class="mr-auto" (onClick)="clear()" [disabled]="loading">
  </dx-button>

</div>

<ng-template #form>
  <dx-form id="form" #formVar [(formData)]="formData" [rtlEnabled]="rtl" [colCount]="colCount" [readOnly]="readOnly"
    [showColonAfterLabel]="true" [showValidationSummary]="false" validationGroup="main">
    <ng-container *ngFor="let field of fields">
      <dxi-item *ngIf="field.editorType && field.type.name !== 'uploader' && !field.hidden" [name]="field?.name"
        [dataField]="field.name" [editorType]="field.editorType" [editorOptions]="field.editorOptions"
        [colSpan]="field.type.colspan || 1">
        <dxi-validation-rule *ngFor="let rule of field.rules" [type]="rule.type" [min]="rule.min" [max]="rule.max"
          [pattern]="rule.pattern">
        </dxi-validation-rule>
        <dxo-label [text]="field.caption" *ngIf="!field.hidden">
        </dxo-label>
      </dxi-item>

      <dxi-item *ngIf="field.type.name === 'uploader' && !field.hidden" [dataField]="field.name"
        editorType="dxFileUploader"
        [editorOptions]="{labelText:'',uploadUrl:uploadUrl,uploadMode:'useButtons',onUploaded:onUploaded,accept:'image/*,audio/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.zip,.rar,.json,.txt',uploadHeaders:{token:token,path:uploadPath, caption:field.name.toLowerCase() }}">
        <dxi-validation-rule *ngFor="let rule of field.rules" [type]="rule.type" [min]="rule.min" [max]="rule.max"
          [pattern]="rule.pattern">
        </dxi-validation-rule>
        <dxo-label [text]="field.caption">
        </dxo-label>
      </dxi-item>

      <dxi-item
        *ngIf="(field.type.name === 'datetime' || field.type.name === 'date' || field.type.name === 'time') && !field.hidden">
        <dp-date-picker dir="rtl" [(ngModel)]="formData[field.name]"
          (ngModelChange)="field.watch ? onDateChange(field, $event) : undefined"
          [mode]="(field.type.name === 'datetime' ? 'daytime' : (field.type.name === 'date' ? 'day' : 'time'))"
          [disabled]="field.type.disabled" placeholder="{{ 'CHOOSE' | translate}}" showTwentyFourHours="true"
          theme="dp-material">
        </dp-date-picker>
        <dxi-validation-rule *ngFor="let rule of field.rules" [type]="rule.type" [min]="rule.min" [max]="rule.max"
          [pattern]="rule.pattern">
        </dxi-validation-rule>
        <dxo-label [text]="field.caption">
        </dxo-label>
      </dxi-item>

    </ng-container>

  </dx-form>

  <div class="border rounded mt-3 p-1" *ngFor="let field of lists">
    <h5 class="text-center mt-1">{{field.caption}}</h5>
    <dx-data-grid [id]="field.name" [dataSource]="formData[field.name]" [activeStateEnabled]="true" [rtlEnabled]="rtl"
      [columnAutoWidth]="false" [cacheEnabled]="true" [columnResizingMode]="'widget'" [allowColumnResizing]="true"
      [allowColumnReordering]="true" [showColumnLines]="true" [showRowLines]="true" [showBorders]="true"
      [rowAlternationEnabled]="true" [twoWayBindingEnabled]="false" (onSaving)="onListSaving(field, $event)">
      <dxo-editing mode="row" [allowUpdating]="!field.readonly" [allowDeleting]="!field.readonly"
        [allowAdding]="!field.readonly">
      </dxo-editing>
      <dxo-scrolling useNative="false" mode="virtual" showScrollbar="never"></dxo-scrolling>
      <dxo-sorting></dxo-sorting>
      <dxo-load-panel [enabled]="true"></dxo-load-panel>
      <dxi-column *ngFor="let col of field.type.columns" [dataField]="col.name" [dataType]="col.type.name || 'string'"
        [caption]="col.caption" [editorOptions]="{mask: col.type.mask, useMaskedValue: true}"
        [alignment]="col.alignment" [cssClass]="(col.alignment === 'left' ? 'leftToRight' : '')" [width]="col.width">
        <dxo-lookup *ngIf="col.type.name === 'select'" [dataSource]="col.type.options" displayExpr="name"
          valueExpr="value" searchEnabled="true">
        </dxo-lookup>
        <dxo-lookup *ngIf="col.type.name === 'select-simple'" [dataSource]="col.type.options" searchEnabled="true">
        </dxo-lookup>
      </dxi-column>
    </dx-data-grid>
  </div>

</ng-template>